export default "__VITE_ASSET__CZuVDa_$__"